import React from 'react'
import { Spin, Tooltip } from 'antd'
import { useIntl } from 'react-intl'
import { differenceInCalendarDays } from 'date-fns'
import { IBurnoutScore } from '@vacationtracker/shared/types/user-insight'

interface BurnoutScoreProps {
  data: IBurnoutScore
  isLoading: boolean
}

const BurnoutScore: React.FC<BurnoutScoreProps> = ({ data, isLoading }) => {
  const { formatMessage } = useIntl()

  if (isLoading) {
    return (
      <div style={{ display: 'grid' }}>
        <Spin size="small" />
      </div>
    )
  }

  if (!data) {
    return (
      <div style={{ textAlign: 'center' }}>
        --
      </div>
    )
  }

  const getLastVacationTooltip = (lastVacationDate: string): string => {
    const vacationDate = new Date(lastVacationDate)
    const today = new Date()

    const diffDays = differenceInCalendarDays(today, vacationDate)

    // Format the date (e.g., May 27, 2025)
    const formattedDate = vacationDate.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })

    return formatMessage({ id: 'insights.lastVacationTooltip' }, { formattedDate, diffDays })
  }

  const score = Number(data.score.toFixed(2)) * 100
  let color = 'green'
  if (score >= 90) {
    color = 'red'
  } else if (score >= 80) {
    color = 'orange'
  } else if (score >= 70) {
    color = 'gold'
  }

  return (
    <Tooltip
      title={`${getLastVacationTooltip(data.lastVacationDate)}`}
    >
      <div className='fade-in' style={{
        width: '100%',
        height: '1rem',
        position: 'relative',
        backgroundColor: '#f0f0f0',
        borderRadius: '4px',
        overflow: 'hidden',
      }}>
        <div style={{
          width: `${score}%`,
          height: '100%',
          backgroundColor: color,
          position: 'absolute',
        }} />
        <div style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: score >= 70 ? '#fff' : '#000',
          fontWeight: 500,
          zIndex: 1,
        }}>
        </div>
      </div>
    </Tooltip>
  )
}

export default BurnoutScore
